import type { SpecSectionField } from 'Components/SpecSection/SpecSection.types';
import type { VehicleElectricalAndMechanicalIssues } from 'Pages/vehicles/helpers/vehicle.schema';

export const MECHANICAL_AND_ELECTRICAL_ISSUES_FIELDS: SpecSectionField<VehicleElectricalAndMechanicalIssues>[] = [
	{
		fieldName: 'hasElectricsProblems',
		isVisible: () => true,
		label: () => 'Disclosed by seller',
		value: ({ hasElectricsProblems }) => <>{`${hasElectricsProblems ? 'Yes' : 'No'}`}</>,
	},
	{
		fieldName: 'electricsProblemsDesc',
		isVisible: () => true,
		label: () => 'Additional information',
		value: ({ electricsProblemsDesc }) => <>{`${electricsProblemsDesc || '-'}`}</>,
	},
];
